import React from 'react';
import styles from './access-denied.module.scss';
import AccessDeniedIcon from 'src/assets/svg/access-denied-icon';

interface IAccessDeniedProps {
	icon?: React.ReactNode;
	headerText?: React.ReactNode;
	infoText?: React.ReactNode;
}

const AccessDenied: React.FC<IAccessDeniedProps> = ({ icon, headerText, infoText }) => {
	return (
		<>
			{icon ?? <AccessDeniedIcon />}
			<div className={styles.headerText}>{headerText ?? <>Access Denied</>}</div>
			<div className={styles.infoText}>
				{infoText ?? (
					<>
						Oops! You no longer have access to <br />
						this account.
					</>
				)}
			</div>
		</>
	);
};

export default AccessDenied;
